module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sites"
  }, [_c('div', {
    staticClass: "panelheader"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.pageName))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "xs": {
        span: 0
      },
      "sm": {
        span: 14
      },
      "md": {
        span: 14
      },
      "lg": {
        span: 18
      }
    }
  }, [_c('div', {
    staticClass: "site-view"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "98%",
      "height": "500px"
    },
    attrs: {
      "center": this.center,
      "zoom": this.zoom
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": false,
        "icon": m.icon,
        "title": m.label
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "site-panel",
    attrs: {
      "xs": {
        span: 24
      },
      "sm": {
        span: 10
      },
      "md": {
        span: 10
      },
      "lg": {
        span: 6
      }
    }
  }, [_c('el-table', {
    staticClass: "site-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "empty-text": "No sites"
    },
    on: {
      "row-click": _vm.goToSite,
      "row-dblclick": _vm.viewSiteInfo
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Sites"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', {
          staticClass: "hidden"
        }, [_vm._v(_vm._s(props.row.id))]), _vm._v(" "), _c('div', {
          staticClass: "name"
        }, [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('div', {
          staticClass: "clear"
        }), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "address"
        }, [_vm._v(_vm._s(props.row.address))])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09a8f50c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sites.vue
// module id = 814
// module chunks = 1